module.exports = __webpack_public_path__ + "img/id-card-clip.58c03d8b.svg";